//@flow
import * as React from 'react';
import {StyleSheet, TouchableOpacity, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import theme, {getCatalogStyle} from '../../../theme-config';
import I18n from '../../../lib/i18n';
import formatUnitType from '../../../lib/TripicaUnitTypeFormatter';
import Icon from '../Icon/Icon';
import config from '../../../config';

const CharacteristicSliderLabel = (props: Props) => {
  const styles = getStyles();
  const formattedUnitType = formatUnitType(props.unitType);
  const {icon, color} = getCatalogStyle(formattedUnitType, theme);

  const getIcon = (direction?: 'row' | 'column') => {
    const iconStyle = direction === 'row' ? {marginRight: 10} : {};

    return props.noIcon ? null : (
      <Icon
        name={icon}
        color={props.lightColors ? theme.overPrimaryColor : color}
        size={20}
        style={iconStyle}
      />
    );
  };

  const getText = () => (
    <Text style={props.lightColors && styles.lightText}>
      {props.labelOverride || I18n.t(`catalog.CATALOG_${formattedUnitType}`)}
    </Text>
  );

  const {direction = 'row'} = props;

  const touchable =
    config.canUseDataRecommendationTool && props.onPressHelpIcon;

  const containerStyle = [
    styles.container,
    direction === 'row' ? styles.rowContainer : styles.columnContainer,
  ];

  return touchable ? (
    <TouchableOpacity
      style={containerStyle}
      onPress={props.onPressHelpIcon}
      activeOpacity={0.8}>
      {getIcon(direction)}
      {getText()}
      <Icon
        name={'info'}
        color={theme.gray.normalLight}
        size={16}
        style={styles.infoIcon}
      />
    </TouchableOpacity>
  ) : (
    <View style={containerStyle}>
      {getIcon(direction)}
      {getText()}
    </View>
  );
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      backgroundColor: 'transparent',
      alignItems: 'center',
    },
    rowContainer: {
      flexDirection: 'row',
    },
    columnContainer: {
      flexDirection: 'column',
    },
    lightText: {
      color: theme.overPrimaryColor,
    },
    infoIcon: {
      marginTop: 4,
    },
    iconHorizontal: {
      marginRight: 10,
    },
  });

type Props = {
  unitType: string,
  lightColors?: boolean,
  onPressHelpIcon: ?Function,
  noIcon: boolean,
  direction?: 'row' | 'column',
  labelOverride?: string,
};

export default CharacteristicSliderLabel;
